import { Component } from '@angular/core';

declare var require: any;

import { routerTransition } from '../../../../../../src/app/ncs/animations/router.animations';
 

@Component({
  selector: 'combinedbilling',
  templateUrl: './combinedbilling.component.html',
  styleUrls: [
    './combinedbilling.component.scss']
  , animations: [routerTransition()]
})

export class CombinedBillingComponent {

}
